module.exports = require("@mui/material/AccordionSummary");